/* This component will be used for the minibasket which opens up from the right in a sidebar/drawer */

import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useRouter } from "next/compat/router";

import styles from "../Basket.module.scss";

import CharityComp from "../../CharityComp";
import ProductTileList from "../ProductTileList";
import EmptyBasket from "../EmptyBasket";
import OrderSummary from "../OrderSummary";
import { getTotalPriceForBenefit } from "@/helpers/charityHelper";
import { updateCartDates } from "@/helpers/cartHelpers";
import { isDonationProduct, isGiftCardType } from "@/helpers/pdpHelpers/priceHelpers";
import { getCookie } from "cookies-next";


function simulateUnhandledRejection() {
  // Create a promise that rejects without a .catch() handler
  new Promise((resolve, reject) => {
    reject(new Error('Simulated unhandled rejection'));
  });
}

export default function BasketComp({ onClose, isFullBasket ,isMobile }) {
  const cart_list = useSelector((state) => state.click.cart_list);
  const [cartList, setCartList] = useState(null);
  const [benefitTotal, setBenefitTotal] = useState(null);
  const openBasket = useSelector((state) => state.click.open_mini_cart);
  const [hideImpactMessage, sethideImpactMessage] = useState(false);
  const nostoPlacements = useSelector((state) => state.nosto.nostoPlacements);
  let lineItems = [];
  let numTotalItems;
  let isEmpty = true;
  let isOnlyOOS = false;
  let checkoutUrl;
  let summary;
  useEffect(() => {
    const updateCart = async () => {
      if(cart_list){
        // Get the value of the cartSyncDate cookie
        const cartSyncDate = getCookie('cartSyncDate');

        // Get today's date in YYYY-MM-DD format
        const today = new Date().toISOString().split('T')[0];

        // Check if the cookie is not present or if today's date is not the same as the date saved in the cookie
        if (!cartSyncDate || new Date(cartSyncDate).toISOString().split('T')[0] !== today) {
          const updatedCart = await updateCartDates(cart_list);
          if (updatedCart) {
            setCartList(updatedCart);
          }
        }
      }
    };

      setCartList(cart_list);
    let benefitResponse = getTotalPriceForBenefit(cart_list);
    if(benefitResponse?.item_total_price)
      setBenefitTotal(benefitResponse.item_total_price);
    sethideImpactMessage(benefitResponse.hide_impact_message);

    // Call updateCart after a 3-second delay
    const timer = setTimeout(() => {
      updateCart();
    }, 3000);

    // Cleanup function to clear the timer if the component unmounts or cart_list changes
    return () => clearTimeout(timer);
  }, [cart_list]);

  //OS-5976 This useEffect is used to update the cart dates when the cart is opened or your-bag page is visited
  // This is to ensure that the cart dates are updated with the valid estimated dates when the user opens the cart or visits the your-bag page
  useEffect(() => {
    const updateCart1 = async () => {
      if(cart_list){
          const updatedCart = await updateCartDates(cart_list);
          if (updatedCart) {
            setCartList(updatedCart);
          }
      }
    };

    if(openBasket || isFullBasket) {
      updateCart1();
    }

  }, [openBasket,isFullBasket]);

  if (cartList) {
    try {
    lineItems = cartList?.lines?.edges;
    if (lineItems) {
      numTotalItems = lineItems.reduce((previousValue, currentValue) => {
        if(isDonationProduct(currentValue?.node?.merchandise?.product) || isGiftCardType(currentValue?.node?.merchandise)){
          return previousValue + currentValue.node.quantity  
          //consider product quantity if its a giftcard or donation product 
        } else {
          return previousValue + (currentValue.node.merchandise.quantityAvailable ? currentValue.node.quantity : 0);
        }
      }, 0);
    }

    if(lineItems && lineItems?.length) {
      isOnlyOOS = true;
      lineItems.map((item) => {
        if(item.node?.merchandise?.quantityAvailable || isDonationProduct(item.node.merchandise.product) || isGiftCardType(item?.node?.merchandise) ) { 
          //check out of stock condition here
          //exclude out of stock condition for giftcard & donation products
          isOnlyOOS = false;
        }
      });
    }
    
    if(isOnlyOOS) {
      isEmpty = false;
      numTotalItems = 0;
    } else {
      isEmpty = typeof numTotalItems !== "undefined" ? numTotalItems <= 0 : true;
    }

    checkoutUrl = cartList?.checkoutUrl;
    // To be passed to OrderSummary component
    summary = {
      lineItemsSubtotalPrice: cartList?.estimatedCost?.subtotalAmount,
      subtotalPriceV2: cartList?.estimatedCost?.totalAmount,
    };
   }
   catch (e) {
    reportError("Minibasket carlist error");
    reportError(e)
   }
  }

  /* ONLY FOR TESTING, SHOULD BE REPLACED WITH ACTUAL COUNTRY LATER | country=1(US) country!=1 (NON US)*/
  let country = 1;
  const router = useRouter();
  if (router.query.country) {
    if (router.query.country !== "1") {
      country = 2;
    }
  }
  //Filtering out of stock items and available items to group them together in cart
  const outOfStockItems = lineItems?.length ? lineItems.filter(data => {
    if(!isDonationProduct(data.node.merchandise.product)){
      return data.node.merchandise.quantityAvailable === 0;
    }
  }): [];
  const availableItems = lineItems?.length ? lineItems.filter(data => {
    return data.node.merchandise.quantityAvailable != 0 || isDonationProduct(data.node.merchandise.product);
  }) : [];

  lineItems = [...outOfStockItems,...availableItems];

  if(typeof numTotalItems === "undefined" ) {
    numTotalItems = 0;
  }

  if (numTotalItems > 0 && getCookie('newrelic_error') === 'unhandle') {
    // Call the function to simulate the unhandled rejection
    simulateUnhandledRejection();
  }else if(numTotalItems > 0 && getCookie('newrelic_error')){
    console.log(xylon123);
  }
  
  return (
    <>
    {/* condition check on the edge case where the cart is empty don't render the referred component */}
      {!isEmpty && <div className={`${styles.sidebar_content} ${isFullBasket?"":styles.height_class}`}>
        <div className={styles.your_bag}>
          <div className={`${styles.heading}`}>
            <div id="BasketHead" className={isFullBasket?`x-large-xs xx-large-sm xx-large-md light ${styles.title_wrapper}`:`xx-large-md xx-large-sm x-large-xs light`}>
              Your bag
            </div>
          </div>
          <div id="#BasketCount" className={`${styles.item} xx-small-xs xx-small-sm x-small-md`}>
            {numTotalItems==1? numTotalItems+" item":numTotalItems+" items"}
          </div>
        </div>

        {isEmpty ? (
          <EmptyBasket />
        ) : (
          <>
          {isFullBasket && !hideImpactMessage && (
           <div className={`basket-charity-wrapper xx-small-xs x-small-sm x-small-md ${styles.charity_wrapper}`}>
              <CharityComp id="#BasketCharity" price={benefitTotal} showChangeCausePartner={true} lineItems={lineItems} isBag={true} charityPopUpFrom = {isFullBasket ? "your-bag" : "mini-basket"}/>
            </div>
          )}
            <div className={styles.product_list}>
              {lineItems && <ProductTileList lineItems={lineItems} isMobile={isMobile} isFullBasket={isFullBasket}/>}
            </div>

            {!isFullBasket && summary && (
              <OrderSummary
                summary={summary}
                checkoutUrl={checkoutUrl}
                country={country}
                isOnlyOOS={isOnlyOOS}
                
              />
            )}
          </>
        )}
        {/* Nosto code to load recommendations*/}
        {!isFullBasket && (<div
          className="nosto_element"
          id="bag-recommendations-desktop"
          dangerouslySetInnerHTML={{
            __html: nostoPlacements["bag-recommendations-desktop"]
              ? nostoPlacements["bag-recommendations-desktop"].html || nostoPlacements["bag-recommendations-desktop"]
              : ""
          }}
        ></div>)}
      </div>}
    </>
  );
}

